import {
  Button,
  Grid,
  IconButton,
  Popover,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import AssignmentIcon from "@material-ui/icons/Assignment";
import GlobitsPagination from "app/common/Component/Table/Pagination";
import { useStylesExtraButton } from "app/common/Component/Table/TableComponent";
import IconDelete from "app/common/Icon/IconDelete";
import IconPen from "app/common/Icon/IconPen";
import {
  LAServiceRequestItemStatusEnum,
  SERVICE_REQUEST_STATUS,
  SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME,
  SERVICE_TREATMENT_TYPE_WARRANTY,
} from "app/common/LocalConst";
import {
  getDateTime,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleTechician,
} from "app/common/LocalFunction";
import { getOrCreateNewByServiceRequestItemId } from "app/services/DiagnosticReportService";
import { useStore } from "app/stores";
import history from "history.js";
import { observer } from "mobx-react";
import React, { memo, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ListTreatmentMobile from "./ListTreatmentMobile";
import IconEye from "app/common/Icon/IconEye";

const ListTreatment = () => {
  const { t } = useTranslation();
  let dataShowTable =
    JSON.parse(localStorage.getItem("dataTableTreatmentCustom")) || {};
  const {
    pageServiceRequestItem,
    searchObject,
    setPageSize,
    handleChangePage,
    handleDeleteNewServiceRequestItem,
    handleOpenTreatmentResultPopup,
    handleOpenAllocationServicePopup,
    listSelectedItem,
    resetSlected,
    setSelectedItem,
    pagingHistoryServiceRequestItem
  } = useStore().patientManagementStore.serviceRequestItemStore;
  const path = window.location.pathname;

  const columns = {
    ...(path !== "/treatment-management/treatment-patient-info-detail" && {
      checkbox: "Checkbox",
    }),
    stt: "STT",
    orderDate: "Ngày điều trị",
    actions: "Thao tác",
    service: "Dịch vụ",
    currentVolumeTreated: "Số lượng điều trị",
    result: "Kết quả",
    department: "Cơ sở",
    isOutsideDepartment: "Làm ngoài cơ sở không",
    room: "Phòng",
    assigner: "Người chỉ định",
    orderDateDetail: "Ngày chỉ định",
    performDate: "Thời gian thực hiện",
    performer: "Người thực hiện",
    hasImg: "Đã up ảnh",
    status: "Trạng thái",
    note: "Ghi chú",
    createdInfo: "Thông tin tạo / sửa",
    createDateInfo: "Ngày tạo HT / Thời gian nhập (theo HT)",
  };

  const dataInitColumn = {
    checkbox:
      path === "/treatment-management/treatment-patient-info-detail"
        ? false
        : true,
    stt: true,
    orderDate: true,
    actions: true,
    service: true,
    currentVolumeTreated: true,
    result: true,
    department: true,
    isOutsideDepartment: true,
    room: true,
    assigner: true,
    orderDateDetail: true,
    performDate: true,
    performer: true,
    hasImg: true,
    status: true,
    note: true,
    createdInfo: true,
    createDateInfo: true,
  };
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isDoctors = isDoctor();
  const isCashiers = isRoleCashier();
  const isAccountants = isRoleHisAccountant();

  // quản lý điều trị:
  // edit: admin, trưởng cớ sở, kỹ thuật viên, bác sĩ
  // xóa: admin

  // quản lý khách hàng:
  // cập nhật: thu ngân, trường cơ sở, kế toán, admin
  // xóa: thu ngân, trường cơ sở, kế toán, admin
  const canEditTreatment =
    isAdmins || isRoleCt || isDoctors || isRoleBranchManagers;
  const canEditPatient =
    isAdmins || isCashiers || isAccountants || isRoleBranchManagers;
  const canDeletePatient =
    isAdmins || isCashiers || isAccountants || isRoleBranchManagers;
  const totalItems = (pageServiceRequestItem?.content || []).reduce(
    (acc, row) => acc + (row?.items?.length || 0),
    0
  );
  let stt = 0;
  // Hàm kiểm tra xem 1 item có đang được chọn hay không
  const isItemSelected = (item) =>
    listSelectedItem.some((it) => it.id === item.id);

  // Lấy danh sách tất cả item trong trang hiện tại
  const allItemsInPage = (pageServiceRequestItem?.content || []).flatMap(
    (row) => row?.items || []
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [visibleColumns, setVisibleColumns] = useState(dataInitColumn);

  useEffect(() => {
    if (Object.keys(dataShowTable).length > 0) {
      setVisibleColumns(dataShowTable);
    }
  }, []);

  const scrollContainerRef = useRef(null);
  return (
    <Grid container spacing={1} className="w-100 m-0">
      <Grid item xs={12}>
        {!isMobile && (
          <>
            <div className="flex justify-end">
              <ExtraButton
                setVisibleColumns={setVisibleColumns}
                visibleColumns={visibleColumns}
                columns={columns}
              />
            </div>
            <div className="table-scroll-wrapper">
              <table
                className="report-table-treatment"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr style={{ background: "#f5f5f5" }}>
                    {visibleColumns["checkbox"] &&
                      path !==
                      "/treatment-management/treatment-patient-info-detail" && (
                        <th>
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedItem(allItemsInPage);
                              } else {
                                resetSlected();
                              }
                            }}
                            checked={
                              listSelectedItem.length > 0 &&
                              listSelectedItem.length === allItemsInPage.length
                            }
                          />
                        </th>
                      )}
                    {visibleColumns["stt"] && <th>STT</th>}

                    {visibleColumns["orderDate"] && (
                      <th>
                        Ngày điều trị{" "}
                        <span style={{ color: "#bf3c3c", fontWeight: "bold" }}>
                          ({totalItems})
                        </span>
                      </th>
                    )}
                    {visibleColumns["actions"] && <th>Thao tác</th>}
                    {visibleColumns["service"] && <th>Dịch vụ</th>}
                    {visibleColumns["currentVolumeTreated"] && (
                      <th>Số lượng điều trị</th>
                    )}
                    {visibleColumns["note"] && <th>Ghi chú</th>}
                    {visibleColumns["result"] && <th>Kết quả</th>}
                    {visibleColumns["department"] && <th>Cơ sở</th>}
                    {visibleColumns["isOutsideDepartment"] && (
                      <th>Làm ngoài cơ sở không</th>
                    )}
                    {visibleColumns["room"] && <th>Phòng</th>}
                    {visibleColumns["assigner"] && <th>Người chỉ định</th>}
                    {visibleColumns["orderDateDetail"] && (
                      <th>Ngày chỉ định</th>
                    )}
                    {visibleColumns["performDate"] && (
                      <th>Thời gian thực hiện</th>
                    )}
                    {visibleColumns["performer"] && <th>Người thực hiện</th>}
                    {visibleColumns["hasImg"] && <th>Đã up ảnh</th>}
                    {visibleColumns["status"] && <th>Trạng thái</th>}
                    {visibleColumns["createdInfo"] && (
                      <th>Thông tin tạo / sửa</th>
                    )}
                    {visibleColumns["createDateInfo"] && (
                      <th>Ngày tạo HT / Thời gian nhập (theo HT)</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {(pageServiceRequestItem?.content || []).map((row, index) =>
                    (row?.items || []).map((item, subIndex) => {
                      const totalVolumnPerSv = item?.totalTreatmentTimes;
                      const usedVolumnPerSv = item?.totalPerformedTimes;

                      stt++;
                      return (
                        <tr key={`${index}-${subIndex}`}>
                          {visibleColumns["checkbox"] &&
                            path !==
                            "/treatment-management/treatment-patient-info-detail" && (
                              <td>
                                <input
                                  type="checkbox"
                                  checked={isItemSelected(item)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedItem([
                                        ...listSelectedItem,
                                        item,
                                      ]);
                                    } else {
                                      setSelectedItem(
                                        listSelectedItem.filter(
                                          (it) => it.id !== item.id
                                        )
                                      );
                                    }
                                  }}
                                />
                              </td>
                            )}
                          {visibleColumns["stt"] && <td>{stt}</td>}
                          {subIndex === 0 && visibleColumns["orderDate"] && (
                            <td rowSpan={row?.items?.length || 1}>
                              {getDateTime(row?.orderDate, "", "DD/MM/YYYY")}{" "}
                              <span style={{ color: "red" }}>
                                ({row?.items?.length})
                              </span>
                            </td>
                          )}
                          {visibleColumns["actions"] && (
                            <td>
                              {canEditTreatment &&
                                path ===
                                "/treatment-management/treatment-patient-info-detail" ? (
                                <div className="flex-center gap-2">
                                  <Tooltip
                                    title="Cập nhật điều trị"
                                    placement="top"
                                    arrow
                                  >
                                    <IconButton
                                      size="small"
                                      onClick={async () => {
                                        if (
                                          item?.itemStatus !==
                                          LAServiceRequestItemStatusEnum
                                            .PROCESSING.value &&
                                          item?.itemStatus !==
                                          LAServiceRequestItemStatusEnum
                                            .FINISHED.value
                                        ) {
                                          try {
                                            let { data } =
                                              await getOrCreateNewByServiceRequestItemId(
                                                item?.id
                                              );
                                            if (data) {
                                              if (scrollContainerRef?.current) {
                                                sessionStorage.setItem(
                                                  "scrollPosition",
                                                  scrollContainerRef.current
                                                    .scrollTop
                                                );
                                              }
                                              history.push(
                                                `/treatment-management/treatment-update-results-detail/${item?.id}`
                                              );
                                            }
                                          } catch (error) {
                                            toast.error(error);
                                          }
                                        } else {
                                          if (scrollContainerRef?.current) {
                                            sessionStorage.setItem(
                                              "scrollPosition",
                                              scrollContainerRef.current
                                                .scrollTop
                                            );
                                          }
                                          history.push(
                                            `/treatment-management/treatment-update-results-detail/${item?.id}`
                                          );
                                        }
                                      }}
                                    >
                                      <IconPen
                                        style={{
                                          color: "#008693",
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>

                                  {isAdmins &&
                                    item?.itemStatus ===
                                    LAServiceRequestItemStatusEnum.NEW
                                      .value && (
                                      <Tooltip
                                        title="Xóa chỉ định dịch vụ"
                                        placement="top"
                                        arrow
                                      >
                                        <div
                                          className="flex"
                                          onClick={() =>
                                            handleDeleteNewServiceRequestItem(
                                              item
                                            )
                                          }
                                        >
                                          <IconDelete />
                                        </div>
                                      </Tooltip>
                                    )}

                                  {SERVICE_REQUEST_STATUS[0].value ===
                                    item?.itemStatus ? (
                                    <></>
                                  ) : (
                                    <>
                                      <Tooltip title="Xem kết quả">
                                        <span
                                          onClick={() => {
                                            handleOpenTreatmentResultPopup(
                                              item
                                            );
                                          }}
                                        >
                                          🖼️🔍
                                        </span>
                                      </Tooltip>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <>
                                  {canEditPatient && (
                                    <div className="flex-center gap-2">
                                      <Tooltip
                                        title="Cập nhật thông tin dịch vụ"
                                        placement="top"
                                        arrow
                                      >
                                        <IconButton
                                          size="small"
                                          className="actionButton"
                                          onClick={() =>
                                            handleOpenAllocationServicePopup(
                                              item?.id
                                            )
                                          }
                                        >
                                          <AssignmentIcon
                                            style={{ color: "#008693" }}
                                          />
                                        </IconButton>
                                      </Tooltip>

                                      {canDeletePatient && (
                                        <Tooltip
                                          title="Xóa chỉ định dịch vụ"
                                          placement="top"
                                          arrow
                                        >
                                          <div
                                            className="flex"
                                            onClick={() =>
                                              handleDeleteNewServiceRequestItem(
                                                item
                                              )
                                            }
                                          >
                                            <IconDelete />
                                          </div>
                                        </Tooltip>
                                      )}

                                      {SERVICE_REQUEST_STATUS[0].value ===
                                        item?.itemStatus ? null : (
                                        <Tooltip title="Kết quả">
                                          <span
                                            onClick={() =>
                                              handleOpenTreatmentResultPopup(
                                                item
                                              )
                                            }
                                          >
                                            🖼️🔍
                                          </span>
                                        </Tooltip>
                                      )}
                                      <Tooltip title="Xem lịch sử">
                                        <div
                                          onClick={() => {
                                            pagingHistoryServiceRequestItem(item?.id);
                                          }}
                                        >
                                          <IconEye />
                                        </div>
                                      </Tooltip>
                                    </div>
                                  )}
                                </>
                              )}
                            </td>
                          )}
                          {visibleColumns["service"] && (
                            <td>
                              <div className="pl-1 pr-1">
                                <div>
                                  <span className="service-code">
                                    {item?.service?.code}
                                  </span>{" "}
                                  <span className="service-name">
                                    {item?.service?.tradeName ||
                                      item?.service?.name}
                                  </span>
                                  {item?.treatmentType ===
                                    SERVICE_TREATMENT_TYPE_WARRANTY && (
                                      <div
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        (dịch vụ bảo hành{" "}
                                        {item?.service?.warrantyService?.name})
                                      </div>
                                    )}
                                  {item?.patientServiceRegisterCode && (
                                    <>
                                      {" - "}
                                      <span
                                        style={{
                                          color: "#888",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {item?.patientServiceRegisterCode}
                                      </span>
                                    </>
                                  )}
                                </div>
                                {item?.service?.serviceTreatmentType ===
                                  SERVICE_TREATMENT_TYPE_TREATMENT_BY_VOLUME ? (
                                  <>
                                    <>
                                      <div className="font-size-12">
                                        {`Số ${row?.service?.soldUnit || "Cc"
                                          } đã dùng: ${usedVolumnPerSv || 0} / ${totalVolumnPerSv || 0
                                          }`}
                                      </div>
                                      <div className="font-size-12">
                                        {`Số ${row?.service?.soldUnit || "Cc"
                                          } còn lại: ${totalVolumnPerSv - usedVolumnPerSv ||
                                          0
                                          } `}
                                      </div>
                                    </>
                                  </>
                                ) : (
                                  <>
                                    <div className="font-size-12">
                                      {`Lần ${item?.treatmentType ===
                                        SERVICE_TREATMENT_TYPE_WARRANTY
                                        ? "bảo hành"
                                        : "điều trị"
                                        }: ${item?.times || 0} ${item?.unLimited
                                          ? "♾️"
                                          : "| " +
                                          (item?.totalTreatmentTimes || 0)
                                        }`}
                                    </div>
                                  </>
                                )}
                                {/* <div className="flex mt-2">
                                <div>
                                  Đã thu:{" "}
                                  <b style={{ color: "green" }}>
                                    {formatMoney(item?.psrTotalBillPatientPaid|| 0)}
                                  </b>
                                </div>
                                <span className="mx-2 text-gray-400">|</span>
                                <div>
                                  Cần thu:{" "}
                                  <b style={{ color: "red" }}>
                                    {formatMoney(item?.psrAmountActuallyPaid)}
                                  </b>
                                </div>
                              </div> */}
                              </div>
                            </td>
                          )}
                          {visibleColumns["currentVolumeTreated"] && (
                            <td>
                              {item?.currentVolumeTreated} {item?.treatUnit}
                            </td>
                          )}
                          {visibleColumns["note"] && (
                            <td>{item?.note || ""}</td>
                          )}
                          {visibleColumns["result"] && (
                            <td>
                              {item?.diagnosticReport ? (
                                <div>
                                  <div>
                                    <strong>Kết luận:</strong>{" "}
                                    {item?.diagnosticReport?.conclude ||
                                      "Không có"}
                                  </div>
                                  <div>
                                    <strong>Ghi chú:</strong>{" "}
                                    {item?.diagnosticReport?.note || "Không có"}
                                  </div>
                                </div>
                              ) : (
                                <i style={{ color: "#999" }}>Chưa có kết quả</i>
                              )}
                            </td>
                          )}
                          {visibleColumns["department"] && (
                            <td>{item?.department?.name || ""}</td>
                          )}
                          {visibleColumns["isOutsideDepartment"] && (
                            <td>{item?.isOutsideDepartment ? "Có" : "Không"}</td>
                          )}
                          {visibleColumns["room"] && (
                            <td>{item?.room?.name || ""}</td>
                          )}
                          {visibleColumns["assigner"] && (
                            <td>{item?.assigner?.staffName || ""}</td>
                          )}
                          {visibleColumns["orderDateDetail"] && (
                            <td>{getDateTime(item?.orderDate)}</td>
                          )}
                          {visibleColumns["performDate"] && (
                            <td>{getDateTime(item?.performDate)}</td>
                          )}
                          {visibleColumns["performer"] && (
                            <td>
                              {item?.encounterParticipants?.map((el, ind) => (
                                <div>
                                  <span className="service-name">
                                    {el?.staff?.staffName}
                                    {": "}
                                  </span>
                                  <span
                                    className="service-code"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "12px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {el?.position?.name}{" "}
                                    {el?.isMain ? " - ⭐" : ""}
                                  </span>
                                </div>
                              ))}
                            </td>
                          )}
                          {visibleColumns["hasImg"] && (
                            <td>{item?.hasImg ? "✔️" : "❌"}</td>
                          )}
                          {visibleColumns["status"] && (
                            <td>
                              <span>
                                {SERVICE_REQUEST_STATUS?.find(
                                  (it) => it.value === item?.itemStatus
                                )?.name || t("Chưa xác định")}
                              </span>
                            </td>
                          )}

                          {visibleColumns["createdInfo"] && (
                            <td>
                              <div>
                                <strong>Tạo:</strong> {item?.createdBy || ""}
                              </div>
                              <div>
                                <strong>Sửa:</strong> {item?.modifiedBy || ""}
                              </div>
                            </td>
                          )}
                          {visibleColumns["createDateInfo"] && (
                            <td>
                              <div>
                                <strong>Tạo HT:</strong>{" "}
                                {getDateTime(item?.createDate)}
                              </div>
                              <div>
                                <strong>Nhập KQ (HT):</strong>{" "}
                                {getDateTime(item?.createDateDiagnosticReport)}
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
        {isMobile && <ListTreatmentMobile />}
        <GlobitsPagination
          pageIndex={searchObject.pageIndex}
          pageSize={searchObject.pageSize}
          totalElements={pageServiceRequestItem?.totalElements}
          totalPages={pageServiceRequestItem?.totalPages}
          setPageIndex={(pageIndex) => handleChangePage(pageIndex)}
          setPageSize={(pageSize) => setPageSize(pageSize)}
        />
      </Grid>
    </Grid>
  );
};

const ExtraButton = ({ setVisibleColumns, visibleColumns, columns }) => {
  const classes = useStylesExtraButton();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const visibleColumnsFormat = Object.entries(visibleColumns);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = !!anchorEl ? "simple-popover" : undefined;
  const onToggle = (index, state) => {
    let newArr = visibleColumnsFormat?.map((el, ind) => {
      if (ind === index) return [el[0], state];
      else return el;
    });
    const obj = Object.fromEntries(newArr);
    setVisibleColumns(obj);

    localStorage.setItem("dataTableTreatmentCustom", JSON.stringify(obj));
    return newArr;
  };

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        onClick={handleClick}
        className="extra-button-table"
      >
        <div className="flex align-center justify-between">
          {"Xem thêm"}
          <Tooltip title="Xem thêm">
            {!!anchorEl ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </Tooltip>
        </div>
      </Button>
      <Popover
        id={id}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography className={classes.typography}>
          {visibleColumnsFormat &&
            visibleColumnsFormat?.map((el, index) => (
              <CustomToggle
                el={el}
                onToggle={onToggle}
                index={index}
                columns={columns}
              />
            ))}
        </Typography>
      </Popover>
    </div>
  );
};

const CustomToggle = ({ onToggle, el, index, columns }) => {
  const [active, setActive] = useState(el[1]);

  const handleClick = (index) => {
    setActive((prev) => !prev);
    if (onToggle) {
      onToggle(index, !active);
    }
  };

  return (
    <div className="flex gap-2 align-center toggle-wraper">
      <div className="toggle-container">
        <div
          className={`custom-toggle ${active ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          <div className="toggle-circle" />
        </div>
        <div className="flex justify-between align-center" style={{ flex: 1 }}>
          <span className="toggle-label">{columns[el[0]]}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(observer(ListTreatment));
